export { default as TestDataConfig } from "./TestDataConfig";
export { default as ElementLocator } from "./ElementLocator";
export { default as Script } from "./Script";
export { default as ElementDetails } from "./ElementDetails";
export { default as Synopsis } from "./Synopsis";
export { default as Elements } from "./Elements";
